function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndeterminate = function SvgIndeterminate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "indeterminate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M1 8L9 8.00001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
SvgIndeterminate.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgIndeterminate"
};
export default SvgIndeterminate;